const locale = {
	PAGE_ERRORS_BACK: 'Torna alla dashboard',

	PAGE_404_TITLE: 'Non trovata',
	PAGE_404_DESCRIPTION:
		"La pagina a cui stai provando ad accedere non esiste. È possibile che l'url sia sbagliato o che l'elemento sia stato eliminato.",

	PAGE_401_TITLE: 'Non autorizzato',
	PAGE_401_DESCRIPTION:
		"Non disponi delle autorizzazioni necessarie per visualizzare la pagina. Contatta un'amministratore per ulteriori informazioni.",

	PAGE_500_TITLE: 'Errore non gestito',
	PAGE_500_DESCRIPTION:
		"Si è verificato un errore nell'applicazione. Contatta l'assistenza per ulteriori informazioni."
};

export default locale;
